<div mat-dialog-title class="dialog-error dialogContainer">
    <label class="labelTitle">{{ 'UNAUTHORIZED_ACCESS_TITLE' | translate }}</label>
</div>
<mat-dialog-content class="dialogContent">
    <div class="dialogMessage">{{ 'UNAUTHORIZED_ACCESS_MESSAGE' | translate }}</div>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialogActionsBtns">
    <button mat-raised-button color="primary" (click)="onLogoutClick()">
        {{ 'NAVIGATION_BAR_LOGOUT' | translate }}
    </button>
</mat-dialog-actions>